<template>
    <section class="chart-container">

        <el-row :gutter="5">
            <!--masterCount: 10
            merchantCount: 2
            orderCount: 34
            orderMoney: 48386500
            orderPlatformMoney: 48022700-->
            <!-- 1订单总数、订单总金额、订单平台总金额、订单安装总金额、工程师总数、商家总数。-->
            <el-col :span="!type?12:4">
                <div class="chart-wrapper">
                    <i class="iconfont icon-dingdanzongshu" style="color:#40c9c6"></i>
                    <div class="chart-wrapper_div">
                        <span>订单总数</span>
                        <span>{{sta.orderCount}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="!type?12:4">
                <div class="chart-wrapper">
                    <i class="iconfont icon-jine" style="color:#f4516c"></i>
                    <div class="chart-wrapper_div">
                        <span>订单总费用</span>
                        <span>{{sta.orderMoney | formatMoney}}</span>
                    </div>


                </div>
            </el-col>

            <el-col :span="4" v-if="type">
                <div class="chart-wrapper">
                    <i class="iconfont icon-jine" style="color:#f4516c"></i>
                    <div class="chart-wrapper_div">
                        <span>工程师总费用</span>
                        <span>{{sta.orderMoney-sta.orderPlatformMoney | formatMoney}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="4" v-if="type">
                <div class="chart-wrapper">
                    <i class="iconfont icon-jine" style="color:#f4516c"></i>
                    <div class="chart-wrapper_div">
                        <span>平台差价</span>
                        <span>{{sta.orderPlatformMoney | formatMoney}}</span>
                    </div>


                </div>
            </el-col>
            <el-col :span="4" v-if="type">
                <div class="chart-wrapper">

                    <i class="iconfont icon-touxiang11" style="color:#1296db"></i>
                    <div class="chart-wrapper_div">
                        <span>工程师总数</span>
                        <span>{{sta.masterCount}}</span>
                    </div>


                </div>
            </el-col>
            <el-col :span="4" v-if="type">
                <div class="chart-wrapper">
                    <i class="iconfont icon-shangjia" style="color:#34bfa3"></i>
                    <div class="chart-wrapper_div">
                        <span>商家总数</span>
                        <span>{{sta.merchantCount}}</span>
                    </div>
                </div>
            </el-col>

        </el-row>

        <el-row style="background: rgb(255, 255, 255);margin:0px 10px;height: 100px;">
            <el-col :span="24">
                <el-form :inline="true" :model="filters" ref="queryForm">

                    <el-form-item class="require" v-if="type">
                        <el-select style="width:100%" filterable v-model="filters.merchantId"
                                   placeholder="请选择商户">
                            <el-option
                                    v-for="item in merchant"
                                    :key="item.userId"
                                    :label="item.name"
                                    :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item>
                        <div class="block">
                            <el-date-picker
                                    format="yyyy-MM-dd"
                                    v-model="date"
                                    type="daterange"
                                    align="right"
                                    placeholder="选择日期范围"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </div>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="drawCharts">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>

        <el-row style="background: rgb(255, 255, 255);padding: 16px 16px 0px;margin:20px 10px;;">


            <el-col :span="12">
                <div id="chartLine" style="width:100%; height:400px;"></div>
            </el-col>
            <el-col :span="12">
                <div id="chartColumn" style="width:100%; height:430px;"></div>
            </el-col>
        </el-row>
    </section>
</template>

<script>
    import echarts from 'echarts'
    import util from '../../common/js/util'
    import NProgress from 'nprogress'
    import {requestPost} from '../../api/api';
    import {data} from "../../common/data";
    import {TMap} from '../../api/map'

    export default {
        data() {
            return {
                filters: {
                    merchantId: '',
                    startTime: '',
                    endTime: '',
                },
                accountType: sessionStorage.getItem('type'),
                sta: {
                    masterCount: '',
                    merchantCount: '',
                    orderCount: '',
                    orderMoney: '',
                    orderPlatformMoney: ''
                },
                pickerOptions: data.pickerOPtions,
                merchant: [],
                chartColumn: null,
                chartLine: null,
                type: sessionStorage.getItem('type') != 2 ? true : false,
                date: [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 7, 0, 0, 0), new Date()]


            }
        },
        filters: {
            formatMoney: function (value, discount) {
                return value / 100;
            },
        },

        methods: {

            drawColumnChart(date, data) {
                this.chartColumn = echarts.init(document.getElementById('chartColumn'));
                this.chartColumn.setOption({

                    tooltip: {},
                    color: ['#3398DB'],
                    legend: {
                        data: ['订单总量'],
                        align: 'left'
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            mark: {show: true},
                            dataView: {show: true, readOnly: false},
                            magicType: {show: true, type: ['line', 'bar']},
                            restore: {show: true},
                            saveAsImage: {show: true}
                        }
                    },
                    calculable: true,
                    xAxis: {

                        type: 'category',
                        data: date
                    },
                    yAxis: [
                        {
                            type: 'value'
                        }
                    ],
                    series: [{
                        name: '订单总量',
                        type: 'bar',
                        barWidth: 30,
                        data: data
                    }]
                });
            },

            drawCharts() {

                this.filters.startTime = util.formatDate.format(new Date(this.date[0]), 'yyyy-MM-dd');
                this.filters.endTime = util.formatDate.format(new Date(this.date[1]), 'yyyy-MM-dd');
                let para = Object.assign({}, this.filters)

                NProgress.start();
                let url = 'sta/staByDate.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {
                        let data = [], orderCount = [], orderMoneySum = [], platformMoneySum = [];
                        if (res.data.length > 0) {
                            /*orderCount":1,"orderMoneySum":2300,
                            "platformMoneySum":2300*/

                            for (var i = 0; i < res.data.length; i++) {

                                data.push((new Date(this.date[0]).getMonth() + 1) + "." + res.data[i].day);
                                orderCount.push(res.data[i].orderCount);
                                orderMoneySum.push(res.data[i].orderMoneySum/100);
                                platformMoneySum.push(res.data[i].platformMoneySum/100);
                            }
                        }

                        this.chartLine = echarts.init(document.getElementById('chartLine'));
                        this.chartLine.setOption({
                            tooltip: {
                                trigger: 'axis'
                            },
                            legend: {
                                data: ['订单总额', '平台费总额']
                            },
                            toolbox: {
                                show: true,
                                feature: {
                                    mark: {show: true},
                                    dataView: {show: true, readOnly: false},
                                    magicType: {show: true, type: ['line', 'bar']},
                                    restore: {show: true},
                                    saveAsImage: {show: true}
                                }
                            },
                            grid: {
                                left: '3%',
                                right: '4%',
                                bottom: '3%',
                                containLabel: true
                            },
                            xAxis: {
                                type: 'category',
                                boundaryGap: false,
                                data: data
                            },
                            yAxis: {
                                type: 'value'
                            },
                            series: [
                                {
                                    name: '订单总额',
                                    type: 'line',
                                    stack: '总量',
                                    data: orderMoneySum
                                },
                                {
                                    name: '平台费总额',
                                    type: 'line',
                                    stack: '总量',
                                    data: platformMoneySum
                                }
                            ]
                        });
                        this.drawColumnChart(data, orderCount);
                    }
                    NProgress.done();
                })


            }
        },

        mounted: function () {
            //统计

            NProgress.start();
            let url = 'sta/getOverview.do';
            requestPost(this, url, {}).then((res) => {

                if (res != '') {


                    this.sta = res.data;
                }
                NProgress.done();
            }).then(() => {
                let para = {
                    userType: 2
                };
                NProgress.start();
                let url = 'user/getByUserType.do';
                requestPost(this, url, para).then((res) => {

                    if (res != '') {

                        this.merchant = res.data;
                    }
                    NProgress.done();
                });

            });

        },
        activated: function () {

        },
        updated: function () {
            this.drawCharts()
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    .chart-container {
        background-color: rgb(240, 242, 245);
        position: relative;
        width: 100%;

        .chart-wrapper {

            height: 108px;
            background: #fff;
            padding: 0px 20px;
            margin: 20px 10px 0px 10px;
            display: flex;
            cursor: pointer;
            color: #666;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            box-shadow: 4px 4px 40px rgba(0, 0, 0, .05);
            border-color: rgba(0, 0, 0, .05);
            i {
                font-size: 48px;
            }
            .chart-wrapper_div {
                display: flex;
                flex-direction: column;
                align-items: center;
                span:first-child {
                    line-height: 18px;
                    color: rgba(0, 0, 0, .45);
                    font-size: 16px;
                    margin-bottom: 12px;
                }
                span:last-child {
                    font-size: 20px;
                }
            }
        }

    }

    /*.chart div {
        height: 400px;
        float: left;
    }*/

    .el-col {
        padding: 30px 20px;
    }
</style>



// WEBPACK FOOTER //
// echarts.vue?11d8b1e9